import React, { createContext, useContext, useState, ReactNode } from "react";
import AppToast, { ToastType } from "../../Components/AppToast";

interface ToastContextType {
  showToast: (type: ToastType, message: string) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};

export const ToastProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [type, setType] = useState<ToastType>("success");

  const showToast = (type: ToastType, message: string) => {
    setType(type);
    setMessage(message);
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <AppToast
        isOpen={isOpen}
        type={type}
        message={message}
        onClose={handleClose}
      />
    </ToastContext.Provider>
  );
};
